import React, {useEffect, useState} from 'react';
import app from "../firebaseConfig/firebaseConfig";
import {getDatabase, onValue, ref, set} from "firebase/database";
import {Link, Route, Routes, useNavigate} from "react-router";
import TranslationEditor from "./TranslationEditor";
import List from "@mui/material/List";
import Container from "@mui/material/Container";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import ProductsEditor from "./ProductsEditor";
import ProductEditor from "./ProductEditor";
import {useUser} from "../managers/userManager/userManager";
import FunctionHandler from "../utils/functionHandler";
import Alert from '@mui/material/Alert';
import CategoryEditor from "./CategoryEditor";
import OrdersPage from "./OrdersPage";
import OrderPage from "./OrderPage";
import PromotionsPage from "./PromotionsPage";
import CartsPage from "./CartsPage";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';

const db = getDatabase(app);
const maintenanceRef = ref(db, '/maintenance/enabled');

function AdminPage(props) {
    const user = useUser();
    const navigate = useNavigate();
    const [permission, setPermission] = useState();
    const [alertOpen, setAlertOpen] = useState(null);
    const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);

    useEffect(() => {
        const unsubscribe = onValue(maintenanceRef, (snapshot) => {
            setMaintenanceEnabled(!!snapshot.val());
        });
        return () => unsubscribe();
    }, []);

    const toggleMaintenance = (e) => {
        const newValue = e.target.checked;
        set(maintenanceRef, newValue);
    };
    useEffect(() => {
        if (user && user.noUser && navigate) {
            navigate('/sign-in')
        }

        if (!user.hasOwnProperty('customPermission')) {
            return;
        }

        if (user.customPermission) {
            setPermission(user.customPermission);
        } else {
            navigate('/sign-in');
        }
    }, [user, navigate]);

    const removeUnusedCarts = () => {
        FunctionHandler.sendData('/removeOldCarts', {}, (data, err) => {
            if (!err) {
                setAlertOpen({message: (err ? data : 'Successfully removed the old carts'), err});
            }
        })
    };

    const removeUnusedDesigns = () => {
        FunctionHandler.sendData('/removeOldDesigns', {}, (data, err) => {
            setAlertOpen({message: (err ? data : 'Successfully removed the old designs'), err});
        })
    };

    return (user.uid && permission &&
        <Container maxWidth="md" sx={{pt: 4}}>
            <Routes>
                <Route path="/translation" element={<TranslationEditor db={db}/>}/>
                <Route path="/products" element={<ProductsEditor/>}/>
                <Route path="/category" element={<CategoryEditor/>}/>
                <Route path="/orders" element={<OrdersPage/>}/>
                <Route path="/carts" element={<CartsPage/>}/>
                <Route path="/order" element={<OrderPage/>}/>
                <Route path="/promotions" element={<PromotionsPage/>}/>
                <Route path="/products/:id" element={<ProductEditor/>}/>
                <Route path="/" element={<List>
                    <Link to="orders" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItemButton>
                            <ListItemText primary={"Orders"}/>
                        </ListItemButton>
                    </Link>
                    <Link to="carts" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItemButton>
                            <ListItemText primary={"Carts"}/>
                        </ListItemButton>
                    </Link>
                    <Link to="translation" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItemButton>
                            <ListItemText primary={"Translation editor"}/>
                        </ListItemButton>
                    </Link>
                    <Link to="products" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItemButton>
                            <ListItemText primary={"Product editor"}/>
                        </ListItemButton>
                    </Link>
                    <Link to="category" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItemButton>
                            <ListItemText primary={"Category editor"}/>
                        </ListItemButton>
                    </Link>
                    <Link to="promotions" style={{textDecoration: 'none', color: 'inherit'}}>
                        <ListItemButton>
                            <ListItemText primary={"Promotions"}/>
                        </ListItemButton>
                    </Link>
                    <ListItemButton onClick={removeUnusedCarts}>
                        <ListItemText primary={"Remove unused carts"}/>
                    </ListItemButton>
                    <ListItemButton onClick={removeUnusedDesigns}>
                        <ListItemText primary={"Remove unused designs"}/>
                    </ListItemButton>
                    <Divider sx={{my: 1}}/>
                    <ListItemButton component="div" disableRipple>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={maintenanceEnabled}
                                    onChange={toggleMaintenance}
                                    color="warning"
                                />
                            }
                            label={maintenanceEnabled ? '🔧 Maintenance mode ON' : 'Maintenance mode OFF'}
                        />
                    </ListItemButton>
                    {alertOpen ? <Alert severity={alertOpen.err ? 'error' : 'success'} onClick={() => setAlertOpen(null)}>{alertOpen.message}</Alert> : ''}
                </List>}/>
            </Routes>
        </Container>
    );
}

export default AdminPage;
